import React from "react";
import SharedControlPanel from "./ControlPanel.shared";

const { CONTROL_PANEL_CONFIGS } = require("../../Common/controlPanelConfig");

export default function TypeAControlPanel(props) {
    return (
        <SharedControlPanel
            {...props}
            panelConfig={CONTROL_PANEL_CONFIGS.typeA}
        />
    );
}
